import FacilityNavigate from "../facilityNavigate";
import FacilityAddress from "../faciityAddress";
import FacilityActivitiesGroupsList from "../facilityActivitiesGroupsList";
import fixedEncodeURIComponent from "../../../helper/encodeUri";

const InfoWindowContent = ({ locationItem, global, searchData }) => {
  return (
    <div
      className={`info-block-list__item ${
        locationItem.discounts.length > 0 && "has-discount"
      }`}
    >
      <div className="info-block-list__content">
        <div className="info-block-list__main">
          <h4 className="info-block-list__title">{locationItem.name}</h4>
          <FacilityAddress
            city={locationItem.city}
            address={locationItem.street}
          />
          <FacilityNavigate
            distance={{
              current: locationItem.distance,
              lat: locationItem.latitude,
              lng: locationItem.longitude,
            }}
            global={global.localization}
            location={searchData.location}
          />
          {locationItem.discounts.length ? (
            <img
              src="/assets/images/discounts.svg"
              alt="percentage icon"
              className="discount-img"
              width="23"
              height="23"
            />
          ) : (
            ""
          )}
        </div>
        {locationItem.activityGroups && (
          <FacilityActivitiesGroupsList
            options={locationItem.activityGroups}
          />
        )}

          <a
          href={`${window.initialState.locationUrl}/${fixedEncodeURIComponent(locationItem.slug)}`}
            target="_blank"
            rel="noopener noreferrer"
            className="button-link"
          >
            {global.localization.moredetails}
          </a>
        
      </div>
    </div>
  );
};
export default InfoWindowContent;
